export default "__VITE_ASSET__ce7bb169__"